module.exports = __webpack_public_path__ + "img/ch.46269e0.svg";